import React from "react";
import { StyledFooter } from "./styles";
import { GithubIcon, LinkedInIcon, MailIcon } from "@components/Icons";
import { ShuttleWithShadow } from "@components/Shuttle";

const Pin = ({ Icon, href, type }) => {
  return (
    <a
      className="pin"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={type}
    >
      <Icon size={30} />
    </a>
  );
};

const Footer = ({ ...props }) => {
  return (
    <StyledFooter {...props}>
      <ShuttleWithShadow
        className="shuttle"
        height={80}
        onClick={() => window.scrollTo(0, 0)}
      />
      <h2>Connect With Me</h2>
      <div className="pins">
        <Pin
          Icon={LinkedInIcon}
          href="https://www.linkedin.com/in/jason-jun-li/"
          type="LinkedIn"
        />
        <Pin
          Icon={GithubIcon}
          href="https://github.com/lijason103"
          type="GitHub"
        />
        <Pin Icon={MailIcon} href="mailto:lijason103@gmail.com" type="Mail" />
      </div>
    </StyledFooter>
  );
};

export default Footer;
